import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, ArrowUpRight } from "@phosphor-icons/react";
import { NAV, BRAND } from "../data/content";

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-2xl bg-[#FAF9F6]/85 border-b border-[#D1CFC7]/40"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 lg:px-12 flex items-center justify-between h-[76px]">
        <Link to="/" data-testid="logo-link" className="flex items-center group">
          <img
            src={BRAND.logo}
            alt="Koreko Direct"
            className="h-9 md:h-10 w-auto object-contain"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "") || "home"}`}
              className={`text-sm font-medium relative transition-colors ${
                loc.pathname === n.to
                  ? "text-[#EB0D0D]"
                  : "text-[#1A1918] hover:text-[#EB0D0D]"
              }`}
            >
              {n.label}
              {loc.pathname === n.to && (
                <span className="absolute -bottom-2 left-0 right-0 h-[2px] bg-[#EB0D0D]" />
              )}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/contatti"
            data-testid="header-cta-preventivatore"
            className="hidden md:inline-flex items-center gap-2 bg-[#1A1918] text-[#FAF9F6] px-5 py-3 text-xs uppercase tracking-[0.15em] font-bold rounded-sm hover:bg-[#EB0D0D] transition-colors"
          >
            Richiedi Preventivo
            <ArrowUpRight size={16} weight="bold" />
          </Link>

          <button
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
            className="lg:hidden p-2"
          >
            {open ? <X size={24} weight="bold" /> : <List size={24} weight="bold" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-[#FAF9F6] border-t border-[#D1CFC7]/50 absolute top-full left-0 right-0 shadow-lg"
        >
          <div className="px-6 py-8 flex flex-col gap-5">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}
                className={`font-display text-2xl tracking-tight ${
                  loc.pathname === n.to ? "text-[#EB0D0D]" : "text-[#1A1918]"
                }`}
              >
                {n.label}
              </Link>
            ))}
            <div className="pt-4 border-t border-[#D1CFC7]/50 mt-2 text-sm text-[#5C5A55]">
              <div>{BRAND.phone}</div>
              <div>{BRAND.email}</div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
